export var routingActionCreator = function (route, alternativeRoute) {
    return {
        type: route,
        payload: {
            openInNewTab: false,
            internal: true
        }
    };
};
